import api from '@/services/Api'

export class ExportService {
  async repairFile(search, sort, order, page, limit, filters) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    const url = '/distributor/repair-file/export' +
      '?search=' + encodeURIComponent(search) +
      '&sort=' + sort +
      '&order=' + order +
      '&filters=' + filters
    const response = await api.get(url, { responseType: 'blob' })

    return response.data
  }
}

export default new ExportService()
